<template>
  <div id="register">
    <div class="top">
      <i class="iconfont icon-zhuce"></i>
    </div>
    <div class="form">
      <input type="text" placeholder="请输入手机号" v-model="phone">
      <input type="text" class="yzm am-fl" placeholder="验证码" v-model="yzm">
      <button class="yzm am-fr" :class="{ disable: this.btnyzm !== '获取验证码'}" @click="sendCode()">{{btnyzm}}</button>
      <input type="password" class="" placeholder="请输入密码" v-model="password1">
      <input type="password" class="" placeholder="再次输入密码" v-model="password2">
      <input type="text" class="" placeholder="真实姓名" v-model="username">
      <input type="text" class="" placeholder="身份证号" v-model="idcard">
      <button style="margin-top: -5px" @click="submit()">注册</button>
      <p>已有账号？<span><router-link class="first" :to="{name: 'zcgl', params: {nr: 'login'}}">返回登录页面</router-link></span>
      </p>
    </div>
    <alert :showModal.sync="showAlert">{{alertMessage}}</alert>
  </div>
</template>

<script>
  import ajax from '@/common/ajax/ajax'
  import alert from '@/components/alert/alert'
  import md5 from 'js-md5'
  import router from '@/router'

  export default {
    name: 'register',
    data () {
      return {
        wait: 60,
        btnyzm: '获取验证码',
        yzm: '',
        phone: '',
        password1: '',
        password2: '',
        alertMessage: '',
        username: '',
        idcard: '',
        showAlert: false
      }
    },
    components: {alert},
    methods: {
      submit: function () {
        if (!this.username && !this.password && !this.idcard && !this.password1 && !this.yzm) {
          this.alertMessage = '您输入的资料不完整，请输入完整后再提交！'
          this.showAlert = true
          return
        }
        if (this.password1 !== this.password2) {
          this.alertMessage = '两次密码不同'
          this.showAlert = true
          return
        }
        function IdentityCodeValid (code) {
          let city = {
            11: '北京',
            12: '天津',
            13: '河北',
            14: '山西',
            15: '内蒙古',
            21: '辽宁',
            22: '吉林',
            23: '黑龙江 ',
            31: '上海',
            32: '江苏',
            33: '浙江',
            34: '安徽',
            35: '福建',
            36: '江西',
            37: '山东',
            41: '河南',
            42: '湖北 ',
            43: '湖南',
            44: '广东',
            45: '广西',
            46: '海南',
            50: '重庆',
            51: '四川',
            52: '贵州',
            53: '云南',
            54: '西藏 ',
            61: '陕西',
            62: '甘肃',
            63: '青海',
            64: '宁夏',
            65: '新疆',
            71: '台湾',
            81: '香港',
            82: '澳门',
            91: '国外 '
          }
          let pass = true

          if (!code || !/^\d{6}(18|19|20)?\d{2}(0[1-9]|1[12])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i.test(code)) {
            pass = false
          } else if (!city[code.substr(0, 2)]) {
            pass = false
          } else {
            if (code.length === 18) {
              code = code.split('')
              // ∑(ai×Wi)(mod 11)
              // 加权因子
              let factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
              // 校验位
              let parity = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']
              let sum = 0
              let ai = 0
              let wi = 0
              for (let i = 0; i < 17; i++) {
                ai = code[i]
                wi = factor[i]
                sum += ai * wi
              }
              if (parity[sum % 11] !== code[17]) {
                pass = false
              }
            }
          }
          return pass
        }

        if (!IdentityCodeValid(this.idcard)) {
          this.alertMessage = '身份证有误'
          this.showAlert = true
          return
        }
        let senddata = {
          username: this.username,
          idcard: this.idcard,
          yzm: this.yzm,
          phone: $.trim(this.phone),
          password: md5(this.password1)
        }
        ajax.register(senddata).then(
          () => {
            this.alertMessage = '恭喜您，注册成功！'
            this.showAlert = true
            this.$watch('showAlert', function () {
              router.push({name: 'zcgl', params: {nr: 'login'}})
            })
          })
      },
      sendCode: function () {
        if (this.btnyzm !== '获取验证码') {
          this.alertMessage = '验证码请求太快请稍等'
          this.showAlert = true
          return
        }
        let myreg = /^(((13[0-9]{1})|(15[0-9]{1})|(18[0-9]{1}))+\d{8})$/
        if (!myreg.test($.trim(this.phone))) {
          this.alertMessage = '手机号有误'
          this.showAlert = true
          return
        }
        let senddata = {
          phone: $.trim(this.phone),
          iszh: false
        }

        ajax.sendCode(senddata).then(
          () => {
            let vm = this

            function time () {
              if (vm.wait === 0) {
                vm.btnyzm = '获取验证码'
                vm.wait = 60
              } else {
                vm.btnyzm = vm.wait + '秒后重新发送'
                vm.wait--
                setTimeout(function () {
                  time()
                }, 1000)
              }
            }

            time()
          })
      }
    },
    created: function () {
      this.$emit('update:titlestr', '资产管理注册')
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// register.vue?082e07f0